import React from "react";
import config from './../../../config/config.json';
const Fallback = () => {
    return (
        <div className='flex items-center justify-center h-screen'
            style={{
                backgroundColor: config.splash_bg,
            }}
        >
            <div>
                <div className="flex content-center">
                    <img src={config.header_logo}  alt="logo 2" className="w-50" />
                </div>
                <div>
                    <section className="dots-container mt-5">
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                    </section>
                </div>
            </div>
        </div>
    );
}
export default Fallback;